import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {getClassAssistContent} from '@/content/classAssist'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {getClassLabel} from '@/utils/class-assist/helpers'
import {getGSClassNamesByLanguage} from '@/utils/goods-and-services/classNames'
import {useLanguage} from '@/utils/i18n/language'
import {routeTo} from '@/utils/router'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

// Every class page, linked from the landing: the industry and sector dropdowns aren't links.
export const ClassAssistAllClasses: FC = () => {
  const language = useLanguage()
  const {t} = useTranslation()
  const {allClassesTitle} = getClassAssistContent(language)
  const classNames = getGSClassNamesByLanguage(language)

  return (
    <>
      <Text variant={TextVariant.h2} align="center">
        {t(allClassesTitle)}
      </Text>
      <ul className="list">
        {Object.keys(classNames).map((classCode) => (
          <li key={classCode} className="item">
            <Text>
              <Link href={routeTo.classAssist.class(classCode)} prefetch={false} legacyBehavior>
                <a className="underline">{getClassLabel(t, classNames, classCode)}</a>
              </Link>
            </Text>
          </li>
        ))}
      </ul>

      <style jsx>{`
        .list {
          column-count: 2;
          column-gap: ${theme.spacing[7]};
          margin-top: ${theme.spacing[6]};
        }
        .item {
          break-inside: avoid;
          list-style-type: disc;
          margin-left: ${theme.spacing[4]};
          padding-bottom: ${theme.spacing[2]};
        }
        @media ${MOBILE_SCREENSIZE} {
          .list {
            column-count: 1;
            margin-top: ${theme.spacing[5]};
          }
        }
      `}</style>
    </>
  )
}
